import React from 'react'

import { oneOf, elementType, string } from 'prop-types'

import CircledArrowRight from 'Pods/Shared/Icons/CircledArrowRight'

import PromoCardWrapper from './PromoCardWrapper'

function PromoCard({ variant, icon: Icon, title, badge = null, href = null }) {
  return (
    <PromoCardWrapper href={href} variant={variant}>
      <Icon />
      <div className="promo-card__content">
        <div className="promo-card__content--title">
          {title}
          {badge && <span className="promo-card__badge">{badge}</span>}
        </div>

        <div className="promo-card__arrow-wrapper">
          <CircledArrowRight className="circled-arrow--responsive" />
        </div>
      </div>
    </PromoCardWrapper>
  )
}

PromoCard.propTypes = {
  variant: oneOf(['sale', 'free']).isRequired,
  icon: elementType.isRequired,
  title: string.isRequired,
  badge: string,
  href: string,
}

PromoCard.displayName = 'PromoCard'

export default PromoCard
